import { useSuspenseQuery } from '@tanstack/react-query'
import { BotAnalyticsQueryOptions, analyticsOverviewQueryOptions } from '../../queries'

type Params = { startDate?: Date; endDate?: Date } & Pick<BotAnalyticsQueryOptions, 'botId' | 'workspaceId'>

export const useAnalyticsOverview = (params: Params) => {
  const { startDate, endDate } = params

  const defaultStartDate = new Date()
  defaultStartDate.setDate(defaultStartDate.getDate() - 30)

  const defaultEndDate = new Date()

  return useSuspenseQuery(
    analyticsOverviewQueryOptions({
      ...params,
      startDate: startDate ?? defaultStartDate,
      endDate: endDate ?? defaultEndDate,
    })
  )
}
